const ErrorState = ({ error }) => <p className="error">Error: {error}</p>;

export default ErrorState;